/**
 * The `EventName` enumeration contains the names of all the available events in the Jan platform.
 */
export enum AssistantEvent {
  /** The `OnAssistantsUpdate` event is emitted when the assistant list is updated. */
  OnAssistantsUpdate = 'OnAssistantsUpdate',
}
